<template>
  <div class="mb-6">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Название операции:</label>
        <input
          v-model="data.name"
          type="text"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          @change="$emit('change')"
          placeholder="Введите название операции"
        />
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Рабочий пост:</label>
        <v-select
          v-model="data.workshop_post_id"
          :options="workshopPostOptions"
          label="name"
          :reduce="option => option.id"
          placeholder="Выберите рабочий пост"
          @update:modelValue="$emit('change')"
        >
          <template #no-options>
            К сожалению, ничего не найдено.
          </template>
        </v-select>
      </div>
    </div>
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">Описание операции:</label>
      <textarea
        ref="descriptionField"
        :value="data.description"
        @input="onDescriptionInput"
        rows="2"
        class="w-full resize-none px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        placeholder="Введите описание операции"
      />
    </div>

    <!-- Прикреплённые для печати файлы операции -->
    <div class="mt-4">
      <div v-if="printFiles.length > 0" class="mb-2 border rounded divide-y">
        <div v-for="(file, index) in printFiles"
             :key="`op-print-${file.file_id || file.file?.id}-${index}`"
             class="p-2 hover:bg-gray-50 flex justify-between items-center">
          <a
            :href="`/api/files/${file.file_id || file.file?.id}/preview`"
            target="_blank"
            class="font-medium text-blue-600 hover:underline truncate"
          >
            {{ file.file?.original_name || file.file?.name || 'Документ' }}
          </a>
          <button
            @click.stop="removePrintFile(index)"
            class="p-1 text-red-600 hover:text-red-800"
            title="Удалить файл"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </button>
        </div>
      </div>
      <input
        ref="printFileInput"
        type="file"
        accept=".pdf,application/pdf"
        class="hidden"
        @change="handlePrintFileSelect"
      />
      <button
        @click="triggerPrintFileUpload"
        :disabled="isUploadingPrintFile"
        class="px-3 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700 text-sm flex items-center disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <span class="mr-1">📎</span> {{ isUploadingPrintFile ? 'Загрузка...' : 'Прикрепить файл' }}
      </button>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import axios from 'axios';

export default {
  components: { vSelect },
  props: {
    data: { type: Object, required: true },
    workshopPostOptions: { type: Array, default: () => [] }
  },
  data() {
    return { isUploadingPrintFile: false };
  },
  computed: {
    printFiles() {
      return Array.isArray(this.data.print_files) ? this.data.print_files : [];
    }
  },
  mounted() {
    this.autoResizeDescription();
  },
  methods: {
    onDescriptionInput(event) {
      this.data.description = event.target.value;
      this.autoResizeDescription();
      this.$emit('change');
    },
    autoResizeDescription() {
      const el = this.$refs.descriptionField;
      if (!el) return;
      el.style.height = 'auto';
      el.style.height = `${el.scrollHeight}px`;
    },
    triggerPrintFileUpload() {
      if (this.isUploadingPrintFile) return;
      this.$refs.printFileInput?.click();
    },
    async handlePrintFileSelect(event) {
      const file = event.target.files?.[0];
      event.target.value = '';
      if (!file) return;
      if (file.type !== 'application/pdf') {
        alert('Допустимы только PDF-файлы');
        return;
      }
      this.isUploadingPrintFile = true;
      try {
        const formData = new FormData();
        formData.append('file', file);
        const { data } = await axios.post('/api/files', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        if (!data.file?.id) throw new Error('Файл не загружен');
        if (!Array.isArray(this.data.print_files)) {
          this.data.print_files = [];
        }
        this.data.print_files.push({ file_id: data.file.id, file: data.file });
        this.$emit('change');
      } catch (error) {
        console.error('Ошибка загрузки файла:', error);
        alert(error.response?.data?.message || 'Не удалось загрузить файл');
      } finally {
        this.isUploadingPrintFile = false;
      }
    },
    removePrintFile(index) {
      if (!Array.isArray(this.data.print_files)) return;
      this.data.print_files.splice(index, 1);
      this.$emit('change');
    }
  }
};
</script>
